import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: any) => ({
	heading: {
		fontSize: theme.typography.pxToRem(15)
	},
	addPhotoContainer: {
		height: 180,
		width: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	addPhoto: {},
	photoContainer: {
		height: 180,
		width: 180,
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	photo: {
		height: 180,
		objectFit: "contain"
	},
	gridList: {
		flexWrap: "nowrap",
		// Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
		transform: "translateZ(0)"
	},
	listRoot: {
		overflow: "hidden"
	}
}));

export default useStyles;
